import getCompanyPapersDocument from '../libs/getCompanyPapersDocument';
import { Context } from './model';

const guards = {
  isCompanyPapersDocumentInvalid: ({ getModuleData }: Context) => {
    const { company } = getModuleData().companyPapersData.viewer;

    const statutesDocument = getCompanyPapersDocument({
      companyProfile: company.profile,
      kybDocuments: company.kybDocuments,
    });

    const errors = statutesDocument?.errors;

    return Boolean(errors && errors.length > 0);
  },
};

export default guards;
